import React, { Component } from "react";
import PropTypes from "prop-types";

import Cards from "../cards-main/";

class CardsByAuthorComponent extends Component {
  constructor(props) {
    super(props);
  }

  componentDidCatch(error) {
    /* eslint-disable-next-line */
    console.log(error);
  }

  render() {
    return (
      <div>
        <Cards api={this.props.relatedbyAuthor} loadMore={true} />
      </div>
    );
  }
}

CardsByAuthorComponent.propTypes = {
  relatedbyAuthor: PropTypes.string
};

export default CardsByAuthorComponent;
